/* eslint-disable sort-keys */
import { Box, Skeleton, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";

const GRID_COLUMNS =
  "minmax(0, 1.8fr) minmax(0, 2fr) minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr)";

interface CoursesTableSkeletonProps {
  rows?: number;
}

export const CoursesTableSkeleton: React.FC<CoursesTableSkeletonProps> = ({ rows = 6 }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      data-testid="courses-table-skeleton"
      sx={ {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        mt: 4,
        minWidth: 0
      } }
    >
      { /* Header delle colonne */ }
      { !isXs && (
        <Box
          sx={ {
            alignItems: "center",
            color: theme.customColors.backgroundPrimaryCta,
            display: "grid",
            fontSize: "0.75rem",
            fontWeight: 600,
            gap: "1.25rem",
            gridTemplateColumns: GRID_COLUMNS,
            userSelect: "none"
          } }
        >
          <Box>{ t("title_training") }</Box>
          <Box>{ t("all_status") }</Box>
          <Box>{ t("type_training") }</Box>
          <Box>{ t("date_start_training") }</Box>
          <Box>{ t("date_end_training") }</Box>
          <Box>{ t("actions") }</Box>
        </Box>
      ) }

      { /* Righe in caricamento */ }
      <Box>
        { Array.from({ length: rows }).map((_, idx) => (
          <Box
            key={ idx }
            sx={ {
              alignItems: "center",
              borderBottom: `1px solid ${theme.customColors.border}`,
              display: "grid",
              gap: "1.25rem",
              gridTemplateColumns: isXs ? "1fr" : GRID_COLUMNS,
              maxWidth: "100%",
              p: "1rem 0",
              width: "100%"
            } }
          >
            <Skeleton variant="text" width="80%" height="1.25rem" />
            <Skeleton variant="rounded" width="4.5rem" height="1.5rem" />
            { !isXs && (
              <>
                <Skeleton variant="text" width="60%" height="1.25rem" />
                <Skeleton variant="text" width="70%" height="1.25rem" />
                <Skeleton variant="text" width="70%" height="1.25rem" />
                <Skeleton variant="rounded" width="6rem" height="1.5rem" />
              </>
            ) }
          </Box>
        )) }
      </Box>
    </Box>
  );
};
